"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("../styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SideItem = function SideItem(_ref) {
  var name = _ref.name,
      Component = _ref.Component,
      url = _ref.url,
      className = _ref.className,
      icon = _ref.icon,
      onClick = _ref.onClick;

  if (Component === 'a') {
    return _react["default"].createElement(_styled.StyledSideItem, {
      as: "a",
      onClick: onClick,
      href: url,
      className: "sideItem ".concat(className || name)
    }, icon, _react["default"].createElement(_styled.StyledName, null, name));
  }

  return _react["default"].createElement(_styled.StyledSideItem, {
    onClick: onClick,
    exact: true,
    as: Component,
    to: url,
    className: "sideItem ".concat(className || name),
    activeClassName: "selected"
  }, icon, _react["default"].createElement(_styled.StyledName, null, name));
};

var _default = SideItem;
exports["default"] = _default;

//# sourceMappingURL=SideItem.js.map